module.exports = __webpack_public_path__ + "static/Colorado_River_Boys_Live-87d1948e3d7b2b5fccff2face4c43bdd.png";